import { dateScalarFromYmdParts } from '../graphqlScalars';

/**
 * Trusted `DateScalar` for the last day of the **local** current month, via `dateScalarFromYmdParts`.
 * Pair with `getStartOfMonthYmd` for inclusive month ranges on the API.
 */
export const getEndOfMonthYmd = (): DateScalar => {
  const now = new Date();

  const currentYear = now.getFullYear();

  const currentMonth = now.getMonth() + 1;

  const lastDayOfMonth = new Date(currentYear, currentMonth, 0).getDate();

  return dateScalarFromYmdParts(currentYear, currentMonth, lastDayOfMonth);
};
